/**
 * Parse template data from URL query parameters
 * Templates are expressed as full module names: {service_module_name}.{tqa_module_name}
 * 
 * Examples:
 * ?template_trigger=evernote.add_tag_to_note
 * ?template_actions=pocket.read_it_later,google_drive.upload_file_from_url
 * ?template_queries=facebook.history_of_link_posts_by_you
 */

export const parseTemplateFromParams = (urlParams) => {
  const template = {}

  const triggerParam = urlParams.get("template_trigger")
  if (triggerParam) {
    template.trigger = {
      full_module_name: triggerParam.trim()
    }
  }

  const queriesParam = urlParams.get("template_queries")
  if (queriesParam) {
    template.queries = queriesParam
      .split(",")
      .map(q => ({ full_module_name: q.trim() }))
      .filter(q => q.full_module_name)
  }

  const actionsParam = urlParams.get("template_actions")
  if (actionsParam) {
    template.actions = actionsParam
      .split(",")
      .map(a => ({ full_module_name: a.trim() }))
      .filter(a => a.full_module_name)
  }

  return Object.keys(template).length > 0 ? template : null
}

export const getServiceModuleNamesFromTemplate = (template) => {
  const serviceNames = new Set()

  if (template.trigger) {
    const [serviceName] = template.trigger.full_module_name.split(".")
    serviceNames.add(serviceName)
  }

  if (template.queries) {
    template.queries.forEach(query => {
      const [serviceName] = query.full_module_name.split(".")
      serviceNames.add(serviceName)
    })
  }

  if (template.actions) {
    template.actions.forEach(action => {
      const [serviceName] = action.full_module_name.split(".")
      serviceNames.add(serviceName)
    })
  }

  return Array.from(serviceNames)
}

export const createStepFromTemplate = (templateStep, service, stepType, stepData = null) => {
  if (!stepData) return null
  
  const connectedChannel = service.live_channels?.find(lc => !lc.offline)
  const isConnected = !!connectedChannel

  const step = {
    id: stepData.id,
    name: stepData.name,
    module_name: stepData.module_name,
    full_module_name: stepData.full_module_name,
    normalized_module_name: stepData.normalized_module_name,
    tier: stepData.tier,
    channel_id: service.id,
    service: {
      allow_multiple_live_channels: service.allow_multiple_live_channels || false,
      brand_color: service.brand_color,
      description_html: service.description_html,
      id: service.id,
      image: service.image,
      live_channels: service.live_channels || [],
      module_name: service.module_name,
      name: service.name
    },
    [`${stepType}_fields`]: stepData?.[`${stepType}_fields`] || [],
    fields: {},
    live_channel_id: isConnected ? connectedChannel.id : null,
    isFromTemplate: true,
    needsConnection: !isConnected,
    needsConfiguration: (stepData?.[`${stepType}_fields`] || []).length > 0
  }

  if (stepType === "trigger" || stepType === "query") {
    step.ingredients = stepData?.ingredients || []
  }

  return step
}
